module.exports = __webpack_public_path__ + "img/reports.570d7151.svg";